import CryptoJS from 'crypto-js';

const API_URL = process.env.REACT_APP_API_URL || '';
const API_PORT = 5000;
const API_KEY = process.env.REACT_APP_API_KEY || 'api-key-sorane-2025';
const API_SECRET = process.env.REACT_APP_API_SECRET || 'api-secret-sorane-2025';

export const getBaseUrl = () => {
  // Explicit override (e.g. local dev): REACT_APP_API_URL=http://localhost:5000
  if (API_URL && API_URL !== 'http://localhost') {
    return `${API_URL}:${API_PORT}`;
  }
  // Same-origin API under /api on the SAME scheme+host+port as the page. In
  // production the page is https://sorane.click and nginx proxies /api/* to the
  // backend, so the API is standard HTTPS on :443 — no separate :5000 port
  // (which laptop/network firewalls often block) and no mixed content.
  const { origin, protocol, hostname } = window.location;
  // Localhost dev without an explicit override still needs the :5000 dev server.
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${protocol}//${hostname}:${API_PORT}`;
  }
  return `${origin}/api`;
};

/**
 * Returns auth headers. For public endpoints, only JWT (if available) is sent
 * so the rate limiter can identify the user tier. For private endpoints,
 * the API key + token are also included.
 */
export const getAuthHeaders = () => {
  const headers = {
    'Content-Type': 'application/json',
  };

  // Always attach JWT if logged in — used by rate limiter for higher limits
  const jwt = getJwtToken();
  if (jwt) {
    headers['Authorization'] = `Bearer ${jwt}`;
  }

  // Always send API key headers — required for private endpoints,
  // ignored by public ones
  const token = CryptoJS.MD5(API_KEY + API_SECRET).toString();
  headers['X-API-Key'] = API_KEY;
  headers['X-Token'] = token;

  return headers;
};

export const getJwtToken = () => localStorage.getItem('jwt_token');
export const setJwtToken = (token) => localStorage.setItem('jwt_token', token);
export const clearJwtToken = () => localStorage.removeItem('jwt_token');
export const isLoggedIn = () => !!getJwtToken();
